import { Navigate, Route } from "react-router-dom";
import QueuePages from "containers/user-work/queue-pages";
import TrainingTakeTestContainer from "containers/my-training-container/training-take-test-container";
import TrainingHistoryContainer from "containers/my-training-container/training-history-container";
import TrainingAssignmentContainer from "containers/my-training-container/training-assignment-container";
import CabinetTasksPage from "./cabinet-tasks-page";
import TasksRouteGuard from "./tasks-route-guard";
import { TrainingPagesFrame } from "./queue-frame";

// The «Užduotys» addresses, inside /app/:companyId. The bare address is the task page,
// the training pages have their own routes, and every other address after /my-work is
// a queue page that queue-pages.tsx looks up by its segment.
export const tasksRoutes = (
  <Route path="my-work" element={<TasksRouteGuard />}>
    <Route index element={<CabinetTasksPage />} />
    <Route element={<TrainingPagesFrame />}>
      <Route path="training/take/:assignmentId" element={<TrainingTakeTestContainer />} />
      <Route path="training/history/:assignmentId" element={<TrainingHistoryContainer />} />
      <Route path="training/:assignmentId" element={<TrainingAssignmentContainer />} />
    </Route>
    <Route path="*" element={<QueuePages />} />
  </Route>
);

// Tasks belong to a company: before one is picked (/app/my-work) the person goes to the company list.
export const noCompanyTasksRoute = <Route path="my-work/*" element={<Navigate to="/app" replace />} />;
